import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseAPIArray, BaseApiService } from '../services/base-api.service';
import { HelpersService } from '../services/helpers.service';
import { ProgressService } from '../services/progress.service';
import { LoadingService } from '../services/loading.service';
import { share } from 'rxjs';
import { HttpQuery } from '../services/http-query';

@Injectable({
  providedIn: 'root',
})
export class CashAdvanceApprovalService extends BaseApiService<any> {
  constructor(
    public override http: HttpClient,
    public override helper: HelpersService,
    public override loading: ProgressService,
    public override loadingService: LoadingService
  ) {
    super(http, helper, loading, loadingService);
    this.endpoint = 'cash-advance-approval';
    this.query = { limit: 0, page: 0 };
  }

  getAllFinance(query?: HttpQuery, notifyChange: Boolean = true): Promise<any> {
    return new Promise((resolve, reject) => {
      const url = this.url_array(['find', 'finance', 'paginate']);
      const payload = this.sanitizeFinanceQuery(query);
      this.loadingService.startLoading();
      this.http.post<BaseAPIArray<any>>(url, payload).subscribe({
        next: ({ data, meta }) => {
          this.data = data;
          this.dataLength = meta.totalData;
          if (notifyChange) {
            this.onDataChanged.next(this.data);
            this.onDataLengthChanged.next(this.dataLength);
          }
          this.loadingService.endLoading();
          return resolve(this.data);
        },
        error: (err) => this.handleError(err, reject),
      });
    });
  }

  private sanitizeFinanceQuery(query?: HttpQuery): HttpQuery {
    const source = { ...(query ?? {}) } as Record<string, any>;
    const sanitized: Record<string, any> = {};

    Object.keys(source).forEach((key) => {
      const value = source[key];
      if (value === undefined || value === null) return;
      if (typeof value === 'string' && value.trim() === '') return;
      sanitized[key] = value;
    });

    return sanitized as HttpQuery;
  }

  getAllApproval(
    query?: HttpQuery,
    notifyChange: Boolean = true
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      const url = this.url_array(['find', 'paginate']);
      this.loadingService.startLoading();
      this.http.post<BaseAPIArray<any>>(url, query).subscribe({
        next: ({ data, meta }) => {
          this.data = data;
          this.dataLength = meta.totalData;
          if (notifyChange) {
            this.onDataChanged.next(this.data);
            this.onDataLengthChanged.next(this.dataLength);
          }
          this.loadingService.endLoading();
          return resolve(this.data);
        },
        error: (err) => this.handleError(err, reject),
      });
    });
  }

  getAllVerification(
    query?: HttpQuery,
    notifyChange: Boolean = true
  ): Promise<any> {
    return new Promise((resolve, reject) => {
      const url = this.url_array(['find', 'paginate-verificator']);
      this.loadingService.startLoading();
      this.http.post<BaseAPIArray<any>>(url, query).subscribe({
        next: ({ data, meta }) => {
          this.data = data;
          this.dataLength = meta.totalData;
          if (notifyChange) {
            this.onDataChanged.next(this.data);
            this.onDataLengthChanged.next(this.dataLength);
          }
          this.loadingService.endLoading();
          return resolve(this.data);
        },
        error: (err) => this.handleError(err, reject),
      });
    });
  }
  
  approve(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const url = this.url_custom('approve');
      this.loadingService.startLoading();
      this.http
        .post<any>(url, data)
        .pipe(share())
        .subscribe({
          next: (data) => {
            this.loadingService.endLoading();
            return resolve(data);
          },
          error: (err) => this.handleError(err, reject),
        });
    });
  }
  
  reject(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const url = this.url_custom('reject');
      this.loadingService.startLoading();
      this.http
        .post<any>(url, data)
        .pipe(share())
        .subscribe({
          next: (data) => {
            this.loadingService.endLoading();
            return resolve(data);
          },
          error: (err) => this.handleError(err, reject),
        });
    });
  }
  
  approveFinance(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const url = this.url_array(['approve', 'finance']);
      this.loadingService.startLoading();
      this.http
        .post<any>(url, data)
        .pipe(share())
        .subscribe({
          next: (data) => {
            this.loadingService.endLoading();
            return resolve(data);
          },
          error: (err) => this.handleError(err, reject),
        });
    });
  }
  
  rejectFinance(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      const url = this.url_array(['reject', 'finance']);
      this.loadingService.startLoading();
      this.http
        .post<any>(url, data)
        .pipe(share())
        .subscribe({
          next: (data) => {
            this.loadingService.endLoading();
            return resolve(data);
          },
          error: (err) => this.handleError(err, reject),
        });
    });
  }
}
